document.addEventListener('DOMContentLoaded',()=>{

  // Only on product pages
  if (window.location.pathname.includes('/products/')) {
    const prod_description = document.querySelector('.product__info .product__accordion');
    prod_description.setAttribute('aria-expanded','true');
    prod_description.setAttribute('open','');
    //prod_description.setAttribute('style', 'overflow: visible; height: auto;');
  }

});

if (window.location.pathname.startsWith('/collections/')) {
  document.addEventListener('DOMContentLoaded', function () {
    const url = new URL(window.location.href);

    if (!url.searchParams.has('filter.v.availability')) {
      const availabilityCheckbox = document.querySelector(
        'input[name="filter.v.availability"][value="1"]'
      );

      if (availabilityCheckbox && !availabilityCheckbox.checked) {
        availabilityCheckbox.checked = true;
        availabilityCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}
